import { render, staticRenderFns } from "./report.vue?vue&type=template&id=2e005c78&scoped=true"
import script from "./report.vue?vue&type=script&lang=ts"
export * from "./report.vue?vue&type=script&lang=ts"
import style0 from "./report.vue?vue&type=style&index=0&id=2e005c78&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e005c78",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2e005c78')) {
      api.createRecord('2e005c78', component.options)
    } else {
      api.reload('2e005c78', component.options)
    }
    module.hot.accept("./report.vue?vue&type=template&id=2e005c78&scoped=true", function () {
      api.rerender('2e005c78', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/final-report/report.vue"
export default component.exports